/* global BX24 */
import React, { useState, useEffect } from 'react';
import NotificationStories from './NotificationStories';

const PATH_TO_BACKEND = process.env.REACT_APP_PATH_TO_BACKEND;

const NotificationButton = () => {
  const [showNotification, setShowNotification] = useState({ show: false, unviewedStories: [], userName: '', userData: null });
  const [unreadCount, setUnreadCount] = useState(2); // По умолчанию 2 непросмотренных истории

  // Проверяем статус уведомлений при загрузке компонента
  useEffect(() => {
    const checkUnreadCount = async () => {
      if (typeof BX24 === 'undefined' || BX24 === null) {
        return; // В режиме разработки оставляем по умолчанию
      }

      try {
        BX24.init(async () => {
          const placementInfo = BX24.placement?.info?.();
          if (placementInfo?.options?.ID) {
            const dealId = placementInfo.options.ID.toString();
            
            // Получаем ID пользователя через сделку
            const response = await fetch(`${PATH_TO_BACKEND}/api/deal-assigned-user`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ dealId }),
            });

            if (response.ok) {
              const data = await response.json();
              if (data.assignedUserId) {
                // Проверяем статус уведомлений
                const statusResponse = await fetch(`${PATH_TO_BACKEND}/api/notification-status/${data.assignedUserId}`);
                if (statusResponse.ok) {
                  const statusData = await statusResponse.json();
                  setUnreadCount(statusData.unreadCount || 0);
                }
              }
            }
          }
        });
      } catch (error) {
        console.error('Ошибка при проверке статуса уведомлений:', error);
      }
    };

    checkUnreadCount();
  }, []);

  const handleClick = async () => {
    // Добавляем небольшую задержку, чтобы дать серверу время на обновление после предыдущих запросов
    await new Promise(resolve => setTimeout(resolve, 100));
    
    // Получаем информацию о непросмотренных историях перед показом
    try {
      if (typeof BX24 !== 'undefined' && BX24 !== null) {
        BX24.init(async () => {
          const placementInfo = BX24.placement?.info?.();
          if (placementInfo?.options?.ID) {
            const dealId = placementInfo.options.ID.toString();
            
            const response = await fetch(`${PATH_TO_BACKEND}/api/deal-assigned-user`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ dealId }),
            });

            if (response.ok) {
              const data = await response.json();
              if (data.assignedUserId) {
                // Добавляем timestamp для избежания кеширования
                const statusResponse = await fetch(`${PATH_TO_BACKEND}/api/notification-status/${data.assignedUserId}?t=${Date.now()}`);
                if (statusResponse.ok) {
                  const statusData = await statusResponse.json();
                  
                  console.log('🔄 Обновленные данные из NotificationButton:', statusData);
                  
                  // При ручном вызове всегда показываем истории (передаем info о непросмотренных для визуальных индикаторов)
                  setShowNotification({ 
                    show: true, 
                    unviewedStories: statusData.unviewedStories || [],
                    userName: statusData.user.name,
                    userData: statusData.user // Передаем полные данные пользователя с полями БД
                  });
                  return;
                }
              }
            }
          }
        });
      }
    } catch (error) {
      console.error('Ошибка при получении статуса историй:', error);
    }
    
    // Fallback для разработки
    setShowNotification({ show: true, unviewedStories: ['bell-info', 'new-features'], userName: 'Пользователь', userData: null });
  };

  const handleClose = async () => {
    setShowNotification({ show: false, unviewedStories: [], userName: '', userData: null });
    
    // Обновляем счетчик после закрытия историй
    await updateUnreadCount();
  };

  // Функция для обновления счетчика непросмотренных уведомлений
  const updateUnreadCount = async () => {
    if (typeof BX24 === 'undefined' || BX24 === null) {
      setUnreadCount(0); // В разработке обнуляем
      return;
    }

    try {
      const placementInfo = BX24.placement?.info?.();
      if (placementInfo?.options?.ID) {
        const dealId = placementInfo.options.ID.toString();
        
        // Получаем ID пользователя через сделку
        const response = await fetch(`${PATH_TO_BACKEND}/api/deal-assigned-user`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ dealId }),
        });

        if (response.ok) {
          const data = await response.json();
          if (data.assignedUserId) {
            // Проверяем обновленный статус уведомлений
            const statusResponse = await fetch(`${PATH_TO_BACKEND}/api/notification-status/${data.assignedUserId}`);
            if (statusResponse.ok) {
              const statusData = await statusResponse.json();
              setUnreadCount(statusData.unreadCount || 0);
            }
          }
        }
      }
    } catch (error) {
      console.error('Ошибка при обновлении счетчика:', error);
    }
  };

  return (
    <>
      <button
        type="button"
        className="rd-icon-btn rd-icon-btn--bell"
        title="Что нового в калькуляторе"
        aria-label="Что нового в калькуляторе"
        onClick={handleClick}
      >
        {unreadCount > 0 && (
          <span className="rd-icon-btn__badge">{unreadCount > 99 ? '99+' : unreadCount}</span>
        )}
      </button>

      {/* Система историй уведомлений для ручного вызова */}
      {showNotification.show && (
        <NotificationStories
          manualTrigger={true}
          onClose={handleClose}
          onStoriesViewed={updateUnreadCount}
          unviewedStories={showNotification.unviewedStories}
          userName={showNotification.userName}
          userData={showNotification.userData}
        />
      )}
    </>
  );
};

export default NotificationButton;